import { Hero } from "@/components/Hero";
import { Pillars } from "@/components/Pillars";
import { Ladder } from "@/components/Ladder";
import { Pricing } from "@/components/Pricing";
import { SiteFooter } from "@/components/SiteFooter";

/*
 * The page, in the order it argues.
 *
 * Hero states the claim. Pillars say who is making it and why they can be
 * trusted. Ladder answers "what does working with you actually look like",
 * which is the question that stops a first-time buyer. Pricing is last
 * because the number only lands once the reader knows what the hour buys.
 *
 * The nav lives in App.tsx, not here — see the note there.
 */
export function Home() {
  return (
    <main>
      <Hero />
      <Pillars />
      <Ladder />
      <Pricing />
      <SiteFooter cta />
    </main>
  );
}
